// extracted by mini-css-extract-plugin
export var topicDropDownBg = "searchFilter-module--topicDropDownBg--3noaS";